/**
 * Created by cbikar on 4/27/18.
 */

define(function (require) {

    window.lpTag = window.lpTag || {};

    var lpUtils = require('utils/lpUtils');
    var Bubble = require("ui/bubble/Bubble");
    var ChatLineStateBubbleView = require("web-agent-views/ChatLineStateBubbleView");
    var ViewController = require('web-agent-framework/ViewController');

    var ChatLineAudioViewController = ViewController.extend({
        ControllerName:'ChatLineAudioViewController',
        chatLineState: {

        },

        LPViewMap:{


        },
        LPClassesMap: {
            audioContainer:".lpview_audio_msg",
            audioEl:".lpview_audio_element",
            playPauseButton:".lp-audio-player-btn",
            seekSlider:".lp-audio-player-seek-slider",
            progress:".lp-audio-player-time-current",
            duration:".lp-audio-player-time-duration"
        },
        initialize:function (constructorData) {
            this.currentView = constructorData.lineView;
            this.squenceId = constructorData.squenceId;
            this.convId = constructorData.convId;
            this.visitorId = constructorData.visitorId;
            this.modelController = constructorData.modelController;
            this.rowData = constructorData.data;
            this.rowData = this.rowData.event ? this.rowData.event : this.rowData;
            this.rowData.conversationId =  constructorData.convId;
            this.rowData.latestAgentId =  constructorData.data.latestAgentId;
            this.rowData.id =  constructorData.data.id;
            this.isFeatureEnabled = constructorData.isFeatureEnabled;
            this.isHistory = constructorData.data.isHistory;
            this.consumerId = this.modelController.getModelParam('chats.' + this.convId +'.visitorInfo.visitorId');
            this.agentId = this.modelController.getModelParam('agent.messagingUserId');
            this._updateProgress = null;
            this._playing = false;
            this._error = false;
            this._duration = 0;
            this._currentTime = 0;
            this._endedProgressResetDelay = null;
            this._isieEdge = (navigator.appName === "Netscape") && (window.navigator.userAgent.indexOf('Edge/') !== -1);
            this._isie11 = (navigator.appName === "Netscape") && (window.navigator.userAgent.indexOf("Trident/7.0") !== -1);
            this.initView();
        },

        events:function () {
            var inputRangeEvent = 'input';
            if(this._isie11) {
                inputRangeEvent = 'change';
            }

            this.bindViewEvent({selector : this.LPClassesMap.playPauseButton, DOMEvent : "click", callback : this.playPause,inView:this.currentView});
            this.bindViewEvent({selector : this.LPClassesMap.seekSlider, DOMEvent : inputRangeEvent, callback : this.seek,inView:this.currentView});

            this.viewEventsHandler.bindEvent({
                appName: this.consumerId,
                UIEvent: 'visitorBlurred',
                callback: function() {
                    lpTag.WebAgent.audioController.pause();
                    this.ended();
                }
            });
        },

        render:function () {
        }
    });

    ChatLineAudioViewController.prototype.initView = function(){
        var listTemplate = require('web-agent-templates/LP_audio_chat_line.html');

        var view =  this.createView({template: listTemplate, wrapWithDiv: false});
        this.addView({viewToAdd : view, targetView : this.currentView,beforeView:this.currentView.firstChild});

        this.audioContainer = this.getFirstElement(this.LPClassesMap.audioContainer, this.currentView);
        this.playPauseButton = this.getFirstElement(this.LPClassesMap.playPauseButton, this.currentView);
        this.seekSlider = this.getFirstElement(this.LPClassesMap.seekSlider, this.currentView);
        this.progress = this.getFirstElement(this.LPClassesMap.progress, this.currentView);
        this.duration = this.getFirstElement(this.LPClassesMap.duration, this.currentView);

        if (!this.isFeatureEnabled) {
            this.lpHide(this.audioContainer);
        }
    };
    ChatLineAudioViewController.prototype.downloadFile = function(){
        this.toggleError(true);
        this.setLoading(true);

        var data =  this.rowData;
        this.modelController.getDownloadUrl({
            conversationId: data.conversationId,
            pathUrl:data.message.relativePath,
            index:this.currentIndex,
            id:data.id,
            done: this.onFileDownloaded.bind(this),
            lastUrl: this.lastUrl,
            isHistory:this.isHistory,
            isAudio: true
        });
    };


    ChatLineAudioViewController.prototype.onFileDownloaded = function(file){
        this._error = false;
        this.audioFileUrl = file.url;
        this.playPause();
    };

    ChatLineAudioViewController.prototype.onAudioStatusChange = function(STATE, value){
        var self = this;
        var controller = lpTag.WebAgent.audioController.AUDIO_STATES;

        this.setLoading(false);

        if (STATE === controller.PLAY) {
            clearTimeout(this._endedProgressResetDelay);
            this._playing = true;
            this._updateProgress = setInterval(function() {
                self.setProgress();
            }, 15);
            this.setPlaying(true);
            this.seekSlider.disabled = false;
        } else if (STATE === controller.DURATION) {
            this.duration.innerHTML = formatAudioTime(value);
            this._duration = value;
        } else if (STATE === controller.PAUSE) {
            this.pause();
        } else if (STATE === controller.ENDED) {
            this.ended();
        } else {
            this._error = true;
            this.ended();
            this.toggleError();
        }
    };

    ChatLineAudioViewController.prototype.playPause = function(){
        if (this.audioFileUrl && this._error === false) {
            if( this._playing === false ) {
                lpTag.WebAgent.audioController.play(this.audioFileUrl, this._currentTime, this.onAudioStatusChange.bind(this));
            } else {
                lpTag.WebAgent.audioController.pause();
            }
        } else {
            this.downloadFile();
        }
    };

    ChatLineAudioViewController.prototype.seek = function(){
        var sliderValue = (this.seekSlider.value - this.seekSlider.min) / (this.seekSlider.max - this.seekSlider.min);
        var percent = sliderValue * 100;
        var setTime = this._duration * sliderValue;
        this._currentTime = setTime;
        this.progress.innerHTML = formatAudioTime(setTime);
        this.setProgress(percent);

        if(this._playing === true) {
            lpTag.WebAgent.audioController.setCurrentTime(setTime);
        }
    };

    ChatLineAudioViewController.prototype.setProgress = function(percent) {
        if(typeof percent === 'undefined') {
            this._currentTime = lpTag.WebAgent.audioController.getCurrentTime();
            percent = Math.round(this._currentTime * (100 / this._duration));
            this.progress.innerHTML = formatAudioTime(this._currentTime);
        }

        if(percent !== this.seekSlider.value) {
            this.seekSlider.value = percent;
            if(!this._isieEdge) {
                this.seekSlider.style.backgroundImage = '-webkit-gradient(linear, left top, right top, color-stop('+percent+'%, #b1b5bc), color-stop('+percent+'%, rgb(255, 255, 255)))';
            }
        }

        if( percent >= 100 ) {
            clearInterval(this._updateProgress);
        }
    };

    ChatLineAudioViewController.prototype.pause = function() {
        this._playing = false;
        this._currentTime = lpTag.WebAgent.audioController.getCurrentTime();
        this.setPlaying(false);
        clearInterval(this._updateProgress);
    };

    ChatLineAudioViewController.prototype.ended = function() {
        var self = this;

        this._playing = false;
        this._currentTime = 0;
        this.audioFileUrl = null;
        lpTag.WebAgent.audioController.setCurrentTime(this._currentTime);
        this.progress.innerHTML = formatAudioTime(this._currentTime);
        this.setPlaying(false);
        clearInterval(this._updateProgress);

        // IE fix...
        if(this._isie11) {
            lpTag.WebAgent.audioController.pause();
        }

        this._endedProgressResetDelay = setTimeout(function() {
            self.setProgress(0);
        }, 250);
    };

    ChatLineAudioViewController.prototype.toggleError = function(forceOff) {
        if(this.playPauseButton.classList.contains('error') || forceOff === true) {
            this.playPauseButton.classList.remove('error');
            this.seekSlider.disabled = false;
        } else {
            this.playPauseButton.classList.add('error');
            this.seekSlider.disabled = true;
        }
    };

    ChatLineAudioViewController.prototype.setPlaying = function(playing) {
        if (playing) {
            this.playPauseButton.classList.add('playing');
        } else {
            this.playPauseButton.classList.remove('playing');
        }
    };

    ChatLineAudioViewController.prototype.setLoading = function(loading) {
        if (loading && !this.playPauseButton.classList.contains('playing')) {
            this.playPauseButton.classList.add('loading');
        } else {
            this.playPauseButton.classList.remove('loading');
        }
    };

    window.ChatLineAudioViewController = ChatLineAudioViewController;

    return ChatLineAudioViewController;

    function formatAudioTime(t) {
        if (isNaN(t))  {
            return '00:00';
        }

        if(t > 0.6 && t < 1.0) {
            t = 1.0;
        }

        var parsedSeconds = parseInt(t, 10);
        var minutes = Math.floor(parsedSeconds / 60);
        var seconds = Math.floor(parsedSeconds % 60);

        if (minutes < 10) {minutes = '0' + minutes;}
        if (seconds < 10) {seconds = '0' + seconds;}

        return minutes + ':' + seconds;
    }

});
